import every from 'lodash/every'
import filter from 'lodash/filter'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'

export function valueFromLabel({ type, label, filterData }) {
  const obj = find(filterData[type].options, { label })
  return obj ? obj.value : null
}

export function labelFromValue({ type, value, filterData }) {
  const obj = find(filterData[type].options, { value })
  return obj ? obj.label : null
}

export function hasActiveFilters(rules) {
  return !every(rules, value => isEmpty(value))
}

/**
 * Checks if the filter `type` is the only active filter in a ruleset
 *
 * @param {String} type filter key
 * @param {Object} rules rules object from list
 * @returns {Boolean} true when the filter type is the only active rule
 */
export function isOnlyFilter(type, rules) {
  const value = rules.filters[type]
  const otherFilters = filter(rules.filters, (v, key) => key !== type)
  return value && otherFilters.every(val => val === null) && !rules.search
}



// WEBPACK FOOTER //
// ./src/utils/filter.js